<template>
  <div class="container aos-init aos-animate" data-aos="fade-up">
    <div class="row"></div>
    <div class="section-title">
      <div class="row">
        <div class="col-md-6 my-auto">
          <h3 align="center">Lista de Banners Cadastrados</h3>
        </div>
      </div>
    </div>
    <br />
    <div style="overflow-x: auto">
      <table
        id="cards"
        class="table table-striped table-hover table-sm tables-custom"
        style="width: 100%"
      >
        <thead>
          <tr>
            <th></th>
            <th>Titulo</th>
            <th>Imagem Pequena</th>
          </tr>
        </thead>
        <tbody v-for="card in pageOfItems" v-bind:key="card.CardId">
          <tr>
            <td>
              <a href="#" @click="confirmarDelete(card)"> Excluir </a>
            </td>
            <td>
              <a
                href="#"
                @click="editarCard(card)"
                data-toggle="modal"
                data-target="#modal_cadastro_banner"
              >
                {{ card.titulo }}
              </a>
            </td>
            <td>
              <img :src="'data:image/png;base64,' + card.imagemPequena" />
            </td>
            <td>{{ card.ordem }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="row">
      <div class="col">
        <jw-pagination
          :items="cardsObj"
          @changePage="onChangePage"
          :styles="customStyles"
          :labels="customLabels"
        ></jw-pagination>
      </div>
    </div>
  </div>
</template>
<style>
a {
  cursor: pointer;
}
.pagination {
  justify-content: center;
  flex-wrap: wrap;
}
</style>

<script>
import { mapActions, mapGetters } from "vuex";
import { bannerAPI } from "@/modules/home";

const customStyles = {
  ul: {},
  li: {},
  a: {
    color: "grey",
  },
};

const customLabels = {
  first: "<<",
  last: ">>",
  previous: "<",
  next: ">",
};

export default {
  computed: {
    ...mapGetters(["token", "isAdmin", "isAuthenticated", "loading"]),
  },
  props: {
    AdminListaCard: { type: Boolean, required: false, default: true },
  },
  data() {
    return {
      ...mapActions(["setLoading"]),
      confirmaDelete: "",
      cards: [],
      cardsObj: [],
      pageOfItems: [],
      customStyles,
      customLabels,
    };
  },
  methods: {
    ...mapActions(["setToken", "setUser", "setAdmin", "logout", "setOutros"]),
    confirmarDelete(card) {
      this.confirmaDelete = "";
      this.$bvModal
        .msgBoxConfirm(
          "Tem certeza que deseja DELETAR permanentemente o banner selecionado?",
          {
            title: "Confirmar Ação",
            size: "sm",
            buttonSize: "sm",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            okVariant: "danger",
            okTitle: "SIM",
            cancelTitle: "NÃO",
          }
        )
        .then((value) => {
          this.confirmaDelete = value;
          if (value === true) {
            this.excluirCard(card);
          }
        });
    },
    editarCard(card) {
      // eslint-disable-next-line no-undef
      this.$store.commit("SET_BANNER", card);
      this.$emit("editBanner");
    },
    excluirCard(card) {
      this.setLoading(true);
      bannerAPI
        .delete(card.bannerId)
        .then((resp) => {
          this.setLoading(false);
          this.$toast("Banner deletado com sucesso", {
            timeout: 2000,
            hideProgressBar: true,
          });
          this.listarCards();
        })
        .catch((resp) => {
          this.setLoading(false);
          this.$toast.error("Erro ao deletar Card", {
            timeout: 2000,
            hideProgressBar: true,
          });
        });
    },
    onChangePage(pageOfItems) {
      // update page of items
      this.pageOfItems = pageOfItems;
    },
    listarCards() {
      this.setLoading(true);
      bannerAPI
        .list()
        .then((resp) => {
          this.cards = resp.data;
          this.setLoading(false);
        })
        .catch((resp) => {
          this.setLoading(false);
        });
    },
  },
  created() {
    this.listarCards();
  },
  watch: {
    cards: function (val) {
      this.cardsObj = val;
    },
  },
};
</script>
